import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { resolveDashboardHomePath } from "../lib/dashboardPaths";

export default function DashboardHomeRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-[60vh] flex items-center justify-center text-sm text-aus-onyx/50"
        data-testid="dashboard-home-redirect-loading"
      >
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <Navigate to={resolveDashboardHomePath(user)} replace />;
}
